import React, { ReactElement, useContext } from 'react'
import { Heading } from '@scentregroup/ui'
import { LinkContext } from '../../context'
import style from './index.module.scss'

export type LinkContent = {
  text: string
  url: string
  newTab?: boolean
  trackingLabel?: string
}

export type ButtonContent = {
  text: string
  onClick: () => void
  trackingLabel?: string
}

interface LinkSectionTrackers {
  clicked?: (label: string) => void
}

export interface LinkSectionPropsType {
  heading: LinkContent | ButtonContent
  links?: LinkContent[]
  trackers?: LinkSectionTrackers
}

const extraLinkProps = (newTab = false): { rel?: string; target?: string } =>
  newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {}

export const LinkSection = ({
  heading,
  links,
  trackers,
}: LinkSectionPropsType): ReactElement => {
  const Link = useContext(LinkContext)

  return (
    <div className={style.linkSection}>
      {'url' in heading ? (
        <Link
          {...extraLinkProps(heading.newTab)}
          to={heading.url}
          className={style.link}
          onClick={() =>
            trackers?.clicked?.(heading.trackingLabel ?? heading.text)
          }
        >
          <Heading type="small" className={style.footerHeading}>
            {heading.text}
          </Heading>
        </Link>
      ) : (
        <button
          onClick={() => {
            trackers?.clicked?.(heading.trackingLabel ?? heading.text)
            heading.onClick()
          }}
        >
          <Heading type="small" className={style.footerHeading}>
            {heading.text}
          </Heading>
        </button>
      )}
      {links && links.length > 0 && (
        <div className={style.footerLinks}>
          {links.map((link, index) => (
            <Link
              {...extraLinkProps(link.newTab)}
              to={link.url}
              key={index}
              className={style.link}
              onClick={() =>
                trackers?.clicked?.(link.trackingLabel ?? link.text)
              }
            >
              {link.text}
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
